import { render, staticRenderFns } from "./InvalidTokenWarning.vue?vue&type=template&id=38382a51&scoped=true&"
import script from "./InvalidTokenWarning.vue?vue&type=script&lang=js&"
export * from "./InvalidTokenWarning.vue?vue&type=script&lang=js&"
import style0 from "./InvalidTokenWarning.vue?vue&type=style&index=0&id=38382a51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38382a51",
  null
  
)

/* custom blocks */
import block0 from "./InvalidTokenWarning.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports